import React from 'react'
import Footer from '../../Components/Footer/footer.component'
import CommonHeader from '../../Components/CommonHeader/common-header.component'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

export default function CreateAccount() {
	const history = useHistory()

	const containerStyle = {
		minHeight: '80vh',
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		backgroundColor: '#f7f8f8',
		padding: '2rem',
		boxSizing: 'border-box',
	}

	const titleStyle = {
		color: '#000',
		fontFamily: 'Montserrat, sans-serif',
		fontWeight: 600,
		fontSize: '2rem',
		textAlign: 'center',
		marginBottom: '2rem',
	}

	const cardsContainerStyle = {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '2rem',
		justifyContent: 'center',
	}

	const cardStyle = {
		maxWidth: '400px',
		minHeight: '200px',
		height: '100%',
		width: '100%',
		padding: '2rem',
		backgroundColor: '#fff',
		borderRadius: '10px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		fontFamily: 'Montserrat, sans-serif',
		boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
	}

	const cardTextStyle = {
		marginBottom: '1.5rem',
		fontSize: '14px',
		fontWeight: 400,
		textAlign: 'center',
		color: '#606060',
		lineHeight: '1.5',
	}

	const buttonStyle = {
		color: '#fff',
		border: 'none',
		backgroundColor: '#5BBCEA',
		padding: '0.75rem 1.5rem',
		borderRadius: '8px',
		cursor: 'pointer',
		fontFamily: 'Montserrat, sans-serif',
		fontWeight: 600,
		fontSize: '14px',
	}

	const {t} = useTranslation();

	return (
		<div>
			<CommonHeader />
			<div style={containerStyle}>
				<div style={titleStyle}> {t("create_account")} </div>
				<div style={cardsContainerStyle}>
					<div style={cardStyle}>
						<span style={cardTextStyle}>
							{t("create_client_account")}
						</span>
						<button
							onClick={() => history.push('/client/signup')}
							style={buttonStyle}
						>
							{t("create_client_account_button")}
						</button>
					</div>

					<div style={cardStyle}>
						<span style={cardTextStyle}>
							{t("create_transporter_account")}
						</span>
						<button
							onClick={() => history.push('/transporter/signup')}
							style={buttonStyle}
						>
							{t("create_transporter_account_button")}
						</button>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}
